export const NOTE_IMAGE_MAX_UPLOAD_SIZE = 20 * 1024 * 1024; // 20MB
export const NOTE_IMAGE_ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
export const NOTE_IMAGE_ACCEPT_STRING = 'image/jpeg,image/png,image/webp,image/gif';
